import styles from "./task-requirements.module.css";

/**
 * A label/value pair, or nothing.
 *
 * Null-guarded on the value rather than the caller: every field on a pick or a
 * requirement is optional on the wire for a real reason (not every product
 * carries a weight, not every requirement carries every field), and a caller
 * that had to guard each one before rendering would repeat the same
 * `value == null ? null : <DetailField .../>` at every call site. One guard
 * here instead.
 */
export function DetailField({
  label,
  value,
}: {
  label: string;
  value?: string | number | null;
}) {
  if (value == null || value === "") return null;
  return (
    <div className={styles.detailField}>
      <span className={styles.detailLabel}>{label}</span>
      <span className={styles.detailValue} title={value + ""}>
        {value}
      </span>
    </div>
  );
}
